import script from "./Siding05Corners.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding05Corners.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__